import { render } from "./Footer.vue?vue&type=template&id=636646fc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=636646fc&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-636646fc"

export default script